import { createAction } from 'redux-actions'
import yoyi from 'src/helpers/fetch/fetchService'
import { labelList } from 'src/api/labelMarket';
import { LabelGroupType } from 'src/containers/labelMarket/type';
import { idTrend } from 'src/api/overview'
import { CrowdGroupType } from 'src/containers/crowdManage/util/types';
import { getArray } from 'utils';

export const CHART_DATA_LOADING = 'CHART_DATA_LOADING'
export const CREATIVE_CENTER_REQUEST = `${CHART_DATA_LOADING}_REQUEST`
export const CREATIVE_CENTER_SUCCESS = `${CHART_DATA_LOADING}_SUCCESS`
export const RECEIVE_PEOPLE_TAG_COUNT = 'RECEIVE_PEOPLE_TAG_COUNT'
export const RECEIVE_SUNBURST_CHART_DATA = 'RECEIVE_SUNBURST_CHART_DATA'
export const RECEIVE_SUNBURST_CHART_ERROR_DATA = 'RECEIVE_SUNBURST_CHART_ERROR_DATA'
export const RECEIVE_MAP_CHART_DATA = 'RECEIVE_MAP_CHART_DATA'
export const RECEIVE_K_LINE_CHART_DATA = 'RECEIVE_K_LINE_CHART_DATA'
export const RECEIVE_ID_TREND_CHART_DATA = 'RECEIVE_ID_TREND_CHART_DATA'
export const RECEIVE_BASE_CHART_DATA = 'RECEIVE_BASE_CHART_DATA'

export const fetchRequest = createAction(CREATIVE_CENTER_REQUEST)
export const fetchSuccess = createAction(CREATIVE_CENTER_SUCCESS)
export const receivePeopleTagCount = createAction(RECEIVE_PEOPLE_TAG_COUNT)
export const receiveSunburstChartData = createAction(RECEIVE_SUNBURST_CHART_DATA)
export const receiveSunburstChartErrorData = createAction(RECEIVE_SUNBURST_CHART_ERROR_DATA)
export const receiveMapChartData = createAction(RECEIVE_MAP_CHART_DATA)
export const receiveKLineChartData = createAction(RECEIVE_K_LINE_CHART_DATA)
export const receiveIdTrendChartData = createAction(RECEIVE_ID_TREND_CHART_DATA)
export const receiveBaseChartData = createAction(RECEIVE_BASE_CHART_DATA)


// 韦恩图
export const fetchPeopleTagCount = payload => async (dispatch) => {
  try {
    const response = await yoyi.get(`dataOverview/idMap`, payload)
    dispatch(receivePeopleTagCount(response))
  } catch (e) {
    yoyi.exceptionMessage(e)
  }
}

// 旭日图第一层
export const fetchSunburstChartData = (type: CrowdGroupType, data?: any[]) => async (dispatch) => {
  try {
    let response = [] as any[]
    if (data) {
      response = data
    } else {
      response = await labelList({
        type: type,
        pageSize: 999,
      }).then(res => getArray(res, 'records'))
    }
    
    const result = response.map(i => {
      return Object.assign({}, i, { levelOne: true, value: i.num || 0 })
    })
    dispatch(receiveSunburstChartData(result))
  } catch (e) {
    yoyi.exceptionMessage(e)
  }
}
// 旭日图下一层
export const fetchNextSunburstChartData = payload => async (dispatch) => {
  try {
    let response: any[] = []
    if (payload.data) {
      response = payload.data
    } else {
      response = await labelList({
        type: payload.type,
        pid: payload.pid,
        metaId: payload.metaId,
        level: payload.level,
        pageSize: 999,
      }).then(res => getArray(res, 'records'))
      // 适配旧版接口
      response.forEach(record => record.id = record.labelId)
    }
    const result = response.map(i => Object.assign({}, i, { value: i.num }))
    dispatch(receiveSunburstChartErrorData({}))
    dispatch(receiveSunburstChartData(result))
  } catch (e) {
    dispatch(receiveSunburstChartErrorData(e))
    yoyi.exceptionMessage(e)
  }
}

// 地图
export const fetchMapChartData = (payload, header?) => async (dispatch) => {
    try {
        let response = await labelList({type: LabelGroupType.person, ...payload}, header)
        const data = getArray(response, 'records')
        .filter(d => !(['城市类型', 'City type'].includes(d.name)))
        .map(d => ({
            ...d,
            name: d.name.replace('中国', '')
        }))
        data.forEach(d => d.id = d.labelId)


    dispatch(receiveMapChartData(data))
  } catch (e) {
    yoyi.exceptionMessage(e)
  }
}

// K线图
export const fetchKLineChartData = payload => async (dispatch) => {
  try {
    const response = await yoyi.get(`dataOverview/boxplot`, payload)
    dispatch(receiveKLineChartData(response))
  } catch (e) {
    yoyi.exceptionMessage(e)
  }
}

// 图表
export const fetchBaseChartData = payload => async (dispatch) => {
  try {
    const { type, param, url } = payload
    const response = await yoyi.get(url, param) as any
    let data = []
    if (type == 'genderReport' || type == 'ageReport') {
      data = response.data.filter(item => !item.name.includes('/'))
    }
    if (type == 'appReport' || type == 'internetReport') {
      data = response
    }
    dispatch(receiveBaseChartData({ type, data }))
  } catch (e) {
    yoyi.exceptionMessage(e)
  }
}

// ID趋势图
export const fetchIdTrendChartData = () => async (dispatch) => {
  try {
    const response = await idTrend()

    dispatch(receiveIdTrendChartData(response))
  } catch (e) {
    yoyi.exceptionMessage(e)
  }
}